import { useState } from "react";
import { Link } from "react-router-dom";
import AuthHeader from "@/components/AuthHeader";
import { PrimaryButton } from "@/components/brand";
import api, { formatApiError } from "@/lib/api";
import Footer from "@/components/Footer";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <AuthHeader tag="ACCOUNT RECOVERY" />
      <div className="flex-1 flex items-center">
        <div className="mx-auto w-full max-w-md px-6 py-16">
          <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400 mb-4">[RESET]</div>
          <h1 className="headline text-5xl text-[#0a0a0a]">Reset access.</h1>
          {done ? (
            <div className="mt-8 border border-gray-200 p-6" data-testid="forgot-success">
              <p className="text-sm text-gray-600">
                If an account exists for <span className="font-semibold text-[#0a0a0a]">{email}</span>, a reset link has been generated.
                Check the backend logs for the link (email delivery is in-app only for this environment).
              </p>
              <Link to="/login" className="mt-4 inline-block text-sm underline text-[#0a0a0a]">Back to sign in</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-10 space-y-6">
              <p className="text-base text-gray-500">Enter your email and we'll generate a secure reset link.</p>
              {error && <div className="border border-orange-500 bg-orange-50 text-orange-700 text-sm px-4 py-3">{error}</div>}
              <div>
                <label className="routa-label">Email</label>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="routa-input" />
              </div>
              <PrimaryButton data-testid="forgot-submit-button" type="submit" disabled={busy} className="w-full">
                {busy ? "Sending…" : "Send reset link"}
              </PrimaryButton>
              <Link to="/login" className="block text-sm text-gray-500 hover:text-[#0a0a0a]">Back to sign in</Link>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
